import { Box, Modal } from "@mui/material";

import ConnectGoogleAccount from "../../organisms/Login/ConnectGoogleAccount";
import CustomToast from "../../utils/cutomToast/CustomToast";

const ConnectToGoogleModal = ({
  open,
  handleClose,
  ConnectGoogle,
  handleSkipForNow,
}: {
  open: boolean;
  handleClose: () => void;
  ConnectGoogle: () => void;
  handleSkipForNow: () => void;
}) => {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          width: "100vw",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box bgcolor={"#FFFFFF"} padding={3} borderRadius={1}>
          <ConnectGoogleAccount
            handleConnectToGoogle={ConnectGoogle}
            handleSkinConnectToGoogle={handleSkipForNow}
            handleFailure={() => {
              CustomToast("Google Login Failed", "error");
            }}
          />
        </Box>
      </Box>
    </Modal>
  );
};

export default ConnectToGoogleModal;
